// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
    production: false,
    /**
     * Cache-busting hash for i18n translation files.
     * Generates a unique hash on each application load to prevent stale translations.
     */
    hash: `${new Date().valueOf()}`,
    msalConfig: {
        auth: {
            clientId: '4cbe6c88-cfad-4ce1-b3a1-4402972e12ae',
            authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a',
            redirectUri: window.location.origin + '/auth',
            postLogoutRedirectUri: window.location.origin,
            navigateToLoginRequestUrl: true
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage,
            storeAuthStateInCookie: true
        },
        system: {
            allowPlatformBroker: false
        }
    },
    apiConfig: [
        {
            scopes: ['https://nemwrdco21.execute-api.us-east-1.amazonaws.com/dev/v1/App.Access'],
            uri: 'https://api.dev.digital-industries.ric-usa.siemens.com/v1'
        }
    ],
    api: {
        backend: 'https://api.dev.digital-industries.ric-usa.siemens.com/v1'
    },
    AWS: {
        region: 'us-east-1',
        documentBucket: 'ric-ia-documents',
        documentBucketSA: 'ric-sa-documents'
    }
};
